import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { EventAvailability } from './event-availability';
export { EventAvailability };
import { eventAvailabilitySchema } from '@schemas/business-objects/event-availability';
import { CandidateFormGroup } from './candidate-form-group';

export class EventAvailabilityFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    hasMedicalConditions: SchemaFormControl;
    medicalConditionDetails: SchemaFormControl;
    disability: SchemaFormControl;
    dataConsentToThirdParty: SchemaFormControl;
    uniformSize: SchemaFormControl;
    hasCriminalConvictions: SchemaFormControl;
    candidateId: SchemaFormControl;
    candidate: CandidateFormGroup;
  };

  declare value: Partial<EventAvailability>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(eventAvailabilitySchema, EventAvailability, data, options);
  }

  get object(): EventAvailability {
    return new EventAvailability(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'candidate':
        return new CandidateFormGroup();
      default:
        return undefined;
    }
  }
}

export class EventAvailabilityFormArray extends PersistedFormArray {
  readonly entityName = 'EventAvailability' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(eventAvailabilitySchema, EventAvailability, options);
  }

  protected override createItemGroup() {
    return new EventAvailabilityFormGroup();
  }

  get array(): EventAvailability[] {
    return this.controls.map(
      (group: EventAvailabilityFormGroup) => group.object,
    );
  }
}

export class EventAvailabilityPersistedArray extends PersistedArray<EventAvailability> {
  readonly entityName = 'EventAvailability' as const;

  constructor(options?: PersistedArrayOptions) {
    super(EventAvailability, options);
  }
}
